import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=d97050ca&"
var script = {}
import style0 from "./Uploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports